export const feedKeys = {
  all: ["feed"] as const,
  currentUser: () => [...feedKeys.all, "current-user"] as const,
  posts: (viewerId: string, limit: number) =>
    [
      "posts",
      "feed",
      "feed",
      viewerId,
      limit,
      "default",
      "chronological-v1",
    ] as const,
  activityPosts: (limit: number) =>
    [
      "activityPosts",
      "feed",
      limit,
      "home",
      "no-preview",
      "chronological-v1",
    ] as const,
  activitySessions: (limit: number) =>
    ["activitySessions", "feed", limit, "chronological-v1"] as const,
  socialFeed: (limit: number) => ["socialFeed", "feed", limit] as const,
  buddyReplies: (limit: number) => ["buddyReplies", "feed", limit] as const,
};
